module.exports = __webpack_public_path__ + "static/media/land.2b974a83.svg";